import { useIntl } from 'react-intl';

import { commonMessages } from 'src/utils/messages';

export const useGetStayDuration = () => {
    const { formatMessage } = useIntl();

    const getDurationFromStartDateToEndDate = ({
        startDate,
        endDate,
    }: {
        startDate?: string;
        endDate?: string | null;
    }) => {
        if (!startDate) return formatMessage(commonMessages.minutes, { value: 0 });

        const from = new Date(startDate);
        const to = endDate ? new Date(endDate) : new Date();

        const diffMs = to.getTime() - from.getTime(); // difference in ms (UTC)
        const totalMinutes = Math.floor(diffMs / 1000 / 60);
        const days = Math.floor(totalMinutes / (60 * 24));
        const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
        const minutes = totalMinutes % 60;

        if (days > 0) {
            return `${formatMessage(commonMessages.days, { value: days })} ${formatMessage(commonMessages.hours, { value: hours })} ${formatMessage(commonMessages.minutes, { value: minutes })}`;
        }
        if (hours > 0) {
            return `${formatMessage(commonMessages.hours, { value: hours })} ${formatMessage(commonMessages.minutes, { value: minutes })}`;
        }
        return formatMessage(commonMessages.minutes, { value: minutes });
    };

    return { getDurationFromStartDateToEndDate };
};
